<template>
  <v-dialog :value="value" persistent :max-width="modal.width">
    <v-card>
      <v-card-title>
        <span class="headline">GB Prime Payment</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              class="form-control"
              :class="{ 'has-error': errors.has('detail') }"
              xs12
              sm12
              md12
            >
              <label>
                <strong>{{ $t('Detail') }}</strong>
              </label>
              <input
                v-model="input.detail"
                v-validate="'max:250|required'"
                name="detail"
                type="text"
              />
              <span v-show="errors.has('detail')" class="text-error"
                >{{ errors.first('detail') }}
              </span>
            </v-flex>
            <br />
            <v-flex class="form-control" :class="{ 'has-error': errors.has('amount') }" xs6 sm6 md6>
              <label>
                <strong>{{ $t('Amount') }}</strong>
              </label>
              <input v-model="input.amount" v-validate="'numeric'" name="amount" type="text" />
              <span v-show="errors.has('amount')" class="text-error"
                >{{ errors.first('amount') }}
              </span>
            </v-flex>
            <v-flex class="form-control" xs6 sm6 md6>
              <label>
                <strong>{{ $t('Delivery Method') }}</strong>
              </label>
              <multiselect
                v-model="input.delivery"
                :show-labels="false"
                track-by="name"
                label="name"
                placeholder="Select one"
                :options="deliveryMethods"
                :searchable="false"
                :allow-empty="false"
              >
                <template slot="singleLabel" slot-scope="{ option }"
                  ><strong>{{ option.name }}</strong></template
                >
              </multiselect>
            </v-flex>
            <v-flex
              class="form-control"
              :class="{ 'has-error': errors.has('message') }"
              xs12
              sm12
              md12
            >
              <label>
                <strong>{{ $t('Response Message') }}</strong>
              </label>
              <AutoresizeTextarea
                v-model="input.response"
                v-validate="'max:500|required'"
                style="white-space: break-spaces"
                name="message"
              />
              <span v-show="errors.has('message')" class="text-error"
                >{{ errors.first('message') }}
              </span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outline color="grey" flat @click="close">Close</v-btn>
        <v-btn v-if="input.create" depressed color="primary" @click="save">Save</v-btn>
        <v-btn v-else depressed color="primary" @click="update">Update</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Multiselect from 'vue-multiselect'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'

export default {
  components: { Multiselect, AutoresizeTextarea },
  props: ['value'],
  data() {
    return {
      dialog: true,
      deliveryMethods: [
        { name: '', code: 0 },
        { name: 'Thailandpost (Normal)', code: 1 },
        { name: 'Thailandpost (Registrated Mail)', code: 2 },
        { name: 'Thailandpost (EMS)', code: 3 },
        { name: 'Kerry Express', code: 4 },
        { name: 'Grab', code: 5 },
        { name: 'Uber', code: 6 },
        { name: 'Skootar', code: 7 },
        { name: 'Lalamove', code: 8 },
        { name: 'Lineman', code: 9 },
        { name: 'SCG', code: 10 },
        { name: 'Nim express', code: 11 },
        { name: 'Other', code: 12 },
        { name: 'Flash Express', code: 13 },
        { name: 'Alpha Fast', code: 14 }
      ]
    }
  },
  computed: {
    input() {
      return this.$store.state.modal.input
    },
    modal() {
      return this.$store.state.modal
    }
  },
  methods: {
    save() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          this.goToErrorInput()
          return false
        }

        this.$emit('addIntentItem', 'payment', this.input)
        this.close()
      })
    },
    update() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          return false
        }
        this.$emit('updatePaymentItem', this.input)
        this.close()
      })
    },
    close() {
      this.$store.commit('modalAssign', { open: false, input: {} })
      this.$emit('input', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/IntentGbPrime.vue